import { Skeleton } from '@portals-platform/ui';
import { useSearch } from '@tanstack/react-router';

export function CallbackPage() {
  const { error, error_description } = useSearch({ from: '/callback' });

  if (error) {
    throw new Error(error_description ?? `Authentication failed: ${error}`);
  }

  return (
    <div className="flex h-screen items-center justify-center bg-[var(--color-background)]">
      <Skeleton className="h-8 w-48" />
    </div>
  );
}
